import styled from "styled-components";

export const StyledPreviousFeaturedMatch = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.figma.base.color_white_100};

  .mls-c-scorebug {
    padding-bottom: 0;
  }

  .mls-c-vertical-match {
    border-bottom: 1px solid
      ${(props) => props.theme.figma.base.color_offwhite_100};
  }
`;

export const StyledPreviousFeaturedMatchWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  min-height: 44px;

  .mls-c-vertical-match-time {
    position: absolute;
    left: 0;
  }

  .mls-c-status-stamp__status {
    position: absolute;
    left: 0;
  }

  .mls-c-vertica-match-broadcaster {
    position: absolute;
    right: 0;
  }

  .mls-c-club__picture,
  picture {
    width: 28px;
  }

  .mls-c-status-stamp__status.-pre {
    font-size: ${({ theme }) =>
      theme.mixins.pxToRem(theme.figma.base.scale_1_375)};

    line-height: ${({ theme }) =>
      theme.mixins.pxToRem(theme.figma.base.scale_1_375)};

    color: ${({ theme }) => theme.figma.base.color_black_25};
  }
`;
